
import Icon from 'JS/components/Icon.vue';
import { FulfillmentType } from 'JS/types/ProductDelivery';
import { ILocalStoreJson } from 'src/js/types/LocalStore';
import { PropType } from 'vue';
import { useBreakpoints } from "JS/composables/breakpoint";

export default {
	name: 'FulfillmentInfo',
	components: {
		Icon
	},
	props: {
		fulfillmentType: String,
		shippingDeliveryDate: String,
		shipZip: String,
		subscriptionFrequency: String,
		localStore: Object as PropType<ILocalStoreJson>,
		mobileLineBreak: Boolean,
		shrinkOnMobile: Boolean
	},
	computed: {
		storeCityState(): string {
			return `${this.localStore.city}, ${this.localStore.state}`;
		},
		isShip(): boolean {
			return this.fulfillmentType == FulfillmentType.StandardShipping;
		},
		isPickup(): boolean {
			return this.fulfillmentType == FulfillmentType.InStorePickup;
		},
		isDelivery(): boolean {
			return this.fulfillmentType == FulfillmentType.LocalDelivery;
		},
		deliveryWindowString(): string {
			return this.localStore.localDeliveryInformation?.label ?? "Local Delivery";
		}
	},
	setup(props) {
		const { isMobile } = useBreakpoints();
		const lineBreak = props.mobileLineBreak && isMobile;
		const size = props.shrinkOnMobile ? 'sm' : 'md';

		return {
			lineBreak,
			size
		};
	}
};
